const smoothScrollSettings = {
  behavior: "smooth",
  block: "start",
  inline: "nearest",
};

const getElement = (selectorOrElement) =>
  selectorOrElement instanceof HTMLElement
    ? selectorOrElement
    : document.querySelector(selectorOrElement);

const smoothScroll = (selectorOrElement) => {
  let scrollToElement = getElement(selectorOrElement);

  if (scrollToElement) {
    scrollToElement.scrollIntoView(smoothScrollSettings);
  }
};

const scrollTop = (selectorOrElement) => {
  let scrollToElement = getElement(selectorOrElement);

  if (scrollToElement) {
    scrollToElement.scrollTop = 0;
  }
};

export { smoothScroll, smoothScrollSettings, scrollTop, getElement };
